<template>
  <div class="card">
    <!-- Card header -->
    <div class="card-header">
      <!-- Title -->
      <h5 class="h3 mb-0">Pedidos</h5>
    </div>
    <!-- Card search -->
    <div class="card-header py-0" v-if="showSearch">
      <!-- Search form -->
      <form>
        <div class="form-group mb-0">
          <base-input
            class="input-group-lg input-group-flush mb-0"
            prepend-icon="fas fa-search"
            placeholder="Search"
            type="search"
            v-model="membersSearch"
          ></base-input>
        </div>
      </form>
    </div>
    <!-- Card body -->
    <div class="card-body">
      <!-- List group -->
      <ul class="list-group list-group-flush list my--3">
        <li v-for="(member, index) in members" :key="index" class="list-group-item px-0">
          <div class="row align-items-center">
            <div class="col-auto"></div>
            <div class="col ml--2">
              <h4 class="mb-0">{{member.client && member.client.razao_social}}</h4>
              <span>Quantidade: {{member.order_items.length}}</span>
            </div>
            <div class="col-auto">
              <router-link
                class="btn btn-sm btn-primary"
                type="button"
                :to="{ name: 'Pedidos', params: {client: member.client_info && member.client_info.client}}"
              >Verificar</router-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="card-footer py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
  </div>
</template>
<script>
// import { Avatar } from 'vue-avatar';

export default {
  name: "general-members-list",
   props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    client: {
      default: "value",
    }
  },
  data() {
    return {
      paginated_data: [],
      members: [],
      clients: [],
    };
  },
  methods: {
    setData(p = null) {
      this.$http.secured
        .get("/api/v1/purchase_orders", {
          params: {
            page: p,
            per_page: 5,
          },
        })
        .then((response) => {
          // setando dados de paginação e a collection produtos
          this.paginated_data = response.data;
          this.members        = response.data.purchase_orders || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    getPedidos() {
      this.$http.secured
        .get("/api/v1/purchase_orders", {})
        .then((response) => {
          this.members = response.data.purchase_orders || [];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
    changePage(page) {
      this.setData(page);
    },
    filterMember(members) {
      let url = "/api/v1/purchase_orders" + members.id;
      this.$http.secured.get(url).then((response) => {
        this.members = [response.data];
      });
    },
    getClients() {
      this.$http.secured
        .get("/api/v1/clients", {})
        .then((response) => {
          this.clients = response.data["clients"];
        })
        .catch((error) => this.setError(error, "Something went wrong"));
    },
  },
  mounted() {
    this.setData();
    this.getPedidos();
    this.getClients();
    this.$root.$on("filterMember", this.filterMember);
  },
};
</script>
